import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteApi, get, post, put } from "../../api/client";
import queryClient from "../../config/queryClient";
import { BlockPayloadInterface } from "../../Constants/Interfaces/payloadInterface/BlockPayload.interface";

export const key = {
  ALL_BLOCKS: "ALL_BLOCKS",
};

export const useGetSchoolBlocks = () =>
  useQuery([key.ALL_BLOCKS], () => {
    return get({ url: "/api/v1/school-block" });
  });

export const useAddSchoolBlock = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: Error) => void;
}) => {
  return useMutation(
    (body: BlockPayloadInterface) => {
      return post({
        url: "/api/v1/school-block/register",
        body,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [key.ALL_BLOCKS],
        });
        onSuccess();
      },

      onError: (error: Error) => {
        onError(error);
      },
    }
  );
};

export const useEditBlock = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: Error) => void;
}) => {
  return useMutation(
    ({ blockId, body }: { blockId: number; body: BlockPayloadInterface }) => {
      return put({
        url: `/api/v1/school-block/${blockId}`,
        body,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [key.ALL_BLOCKS],
        });
        onSuccess();
      },
      onError: (error: Error) => {
        onError(error);
      },
    }
  );
};

export const useRemoveBlock = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: Error) => unknown;
}) => {
  return useMutation(
    (blockId: number) => {
      const parameters = {
        blockId,
      };
      const includeToken = true;
      return deleteApi(
        `/api/v1/school-block/${blockId}`,
        includeToken,
        parameters
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [key.ALL_BLOCKS],
        });
        onSuccess();
      },
      onError: (error: Error) => {
        onError(error);
      },
    }
  );
};
